var _path, _ellipse, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconShoes = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 65,
  height: 65,
  viewBox: "0 0 65 65",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.5 65C50.4493 65 65 50.4493 65 32.5C65 14.5507 50.4493 0 32.5 0C14.5507 0 0 14.5507 0 32.5C0 50.4493 14.5507 65 32.5 65Z",
  fill: "#BCD9C9"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 30.5,
  cy: 33,
  rx: 18.5,
  ry: 20,
  fill: "white"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 33,
  r: 20.25,
  stroke: "#727D79",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.1098 25.9596L21.1097 25.9596C20.7575 26.0926 20.525 26.4271 20.525 26.8004V36.4004C20.525 36.8987 20.9352 37.3004 21.4375 37.3004H42.5625C43.0648 37.3004 43.475 36.8987 43.475 36.4004V34.1668C43.475 32.2291 42.1315 30.5845 40.2146 30.1651L35.6128 29.1578L30.8802 26.0513C30.8802 26.0513 30.8801 26.0512 30.88 26.0512C30.7303 25.9523 30.5551 25.9004 30.375 25.9004H28.75C28.4913 25.9004 28.2468 26.0081 28.0735 26.1967L28.0734 26.1968C26.5563 27.8527 23.6314 27.8528 22.1142 26.1969C21.8618 25.9197 21.4625 25.8271 21.1098 25.9596ZM22.35 35.5004V28.6242C24.4966 29.7419 27.3569 29.3753 29.1344 27.7004H30.0997L34.745 30.7496C34.8375 30.8103 34.9415 30.8554 35.0535 30.8789C35.0537 30.879 35.0538 30.879 35.054 30.879L39.8192 31.9236L39.8193 31.9237C40.881 32.1555 41.65 33.1012 41.65 34.1668V35.5004H22.35Z",
  fill: "#EE8322",
  stroke: "#EE8322",
  strokeWidth: 0.2
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconShoes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-shoes.7fbc520186d8983532982e0d33d23456.svg";